/* eslint-disable class-methods-use-this */

import News from "./interfaces/_News";

import { makeFetchDetail, makeFetchList, throwUnlessOk } from "./_microcms-utils";
import Exhibitor from "./interfaces/_Exhibitor";
import { MicroCMSListResponse } from "./interfaces/_microcms-types";
import { EXHIBITOR_LIST_LIMIT, NEWS_LIST_LIMIT } from "./_constants";

const { MICRO_CMS_SERVICE_DOMAIN, MICRO_CMS_API_KEY } = window;


export default class MicroCMSAdapter {
  async getNewsListAsync(paged: number, limit?: number): Promise<MicroCMSListResponse<News>> {
    const actualLimit = limit ?? NEWS_LIST_LIMIT;
    return makeFetchList(MICRO_CMS_SERVICE_DOMAIN, MICRO_CMS_API_KEY, "news", {
      limit: actualLimit,
      offset: actualLimit * (paged - 1),
    })
      .then((res) => {
        throwUnlessOk(res);
        return res.json();
      });
  }

  async getNewsDetailAsync(id: string): Promise<News> {
    return makeFetchDetail(MICRO_CMS_SERVICE_DOMAIN, MICRO_CMS_API_KEY, "news", id)
      .then((res) => {
        throwUnlessOk(res);
        return res.json();
      });
  }

  async getExhibitorListAsync(): Promise<MicroCMSListResponse<Exhibitor>> {
    return makeFetchList(MICRO_CMS_SERVICE_DOMAIN, MICRO_CMS_API_KEY, "exhibitors", {
      limit: EXHIBITOR_LIST_LIMIT,
    })
      .then((res) => {
        throwUnlessOk(res);
        return res.json();
      });
  }

  async getExhibitorDetailAsync(id: string): Promise<Exhibitor> {
    return makeFetchDetail(MICRO_CMS_SERVICE_DOMAIN, MICRO_CMS_API_KEY, "exhibitors", id)
      .then((res) => {
        throwUnlessOk(res);
        return res.json();
      });
  }
}
